import { useNavigate } from "react-router-dom";
import { PlanCard } from "../../components/PlanCard";
import { PageHeader, StatePanel } from "../../components/ui";
import { t } from "../../i18n";
import { useAppStore } from "../../state/appStore";
export function PlanResultsPage() {
  const navigate = useNavigate();
  const result = useAppStore((state) => state.result);
  const selectPlan = useAppStore((state) => state.selectPlan);
  if (!result)
    return (
      <StatePanel
        title="No plans yet"
        body="Tell Spot what you have time for and your plans will appear here."
      />
    );
  return (
    <div className="page">
      <PageHeader
        back={() => navigate("/")}
        eyebrow={t.plans.eyebrow}
        title={t.plans.title}
      />
      <p className="page-intro">{t.plans.intro}</p>
      <div className="horizontal-plans">
        {result.plans.map((plan) => (
          <PlanCard
            key={plan.id}
            plan={plan}
            onSelect={() => {
              selectPlan(plan.id);
              navigate(`/plans/${plan.id}`);
            }}
          />
        ))}
      </div>
      <div className="pager" aria-hidden>
        {result.plans.map((_, index) => (
          <span className={index === 0 ? "active" : ""} key={index} />
        ))}
      </div>
    </div>
  );
}
